import { DatePickerC } from 'components'
import { addDays, differenceInCalendarDays } from 'date-fns'
import { useLoadOrderParameters } from 'modules/setting/hooks'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const ProposalValidity = () => {
  const [days, setDays] = useState(0)
  const [maxDate, setMaxDate] = useState<Date | null>(null)

  const { data: orderParameters }: any = useLoadOrderParameters({})

  const { setValue, watch } = useFormContext()

  const proposalValidity = watch('proposalValidity')

  useEffect(() => {
    const numberDays =
      orderParameters?.data?.find(
        (item: any) => item?.orderId === 'DIAS_VALIDADE_PROPOSTA'
      ).orderDescription || 0

    if (numberDays) {
      const mDate = addDays(new Date(), numberDays)
      setMaxDate(mDate)
    }
  }, [orderParameters?.data])

  useEffect(() => {
    setValue('proposalValidityMaxDay', maxDate)
  }, [maxDate, setValue])

  useEffect(() => {
    if (!proposalValidity && maxDate) {
      setValue('proposalValidity', maxDate)
    }
  }, [proposalValidity, setValue, maxDate])

  useEffect(() => {
    const daysDiff = differenceInCalendarDays(
      new Date(proposalValidity),
      new Date()
    )
    setDays(daysDiff)
  }, [proposalValidity])

  return (
    <DatePickerC
      name={`proposalValidity`}
      label={`Validade da Proposta (${days} ${
        Math.abs(days) === 1 ? 'dia' : 'dias'
      })`}
      inputFormat="dd/MM/yyyy"
      minDate={new Date()}
      maxDate={new Date(maxDate || '')}
    />
  )
}
